export default {
  name: 'XYConfirmDialog',
  data: function data() {
    return {
      title: '',
      titleCenter: false,
      visible: false,
      confirmBtnType: 'primary',
      confirmBtnText: '',
      cancelBtnText: '',
      message: '',
      onConfirm: null,
      onCancel: null
    };
  },
  computed: {
    isPrimaryConfirmBtn: function isPrimaryConfirmBtn() {
      return this.confirmBtnType === 'primary';
    },
    isDangerConfirmBtn: function isDangerConfirmBtn() {
      return this.confirmBtnType === 'danger';
    }
  },
  methods: {
    close: function close() {
      this.visible = false;
      this.$destroy();
      this.$el.parentNode.removeChild(this.$el);
    },
    cancel: function cancel() {
      if (typeof this.onCancel === 'function') {
        this.onCancel(this);
      }
      this.close();
    },
    confirm: function confirm() {
      if (typeof this.onConfirm === 'function') {
        this.onConfirm(this);
      }
      this.close();
    }
  }
};